/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_View_PaintInputs */

const en_landing_studio_view_paint = /** @type {(inputs: Landing_Studio_View_PaintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paint`)
};

const zh_landing_studio_view_paint = /** @type {(inputs: Landing_Studio_View_PaintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`涂抹`)
};

/**
* | output |
* | --- |
* | "Paint" |
*
* @param {Landing_Studio_View_PaintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_view_paint = /** @type {((inputs?: Landing_Studio_View_PaintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_View_PaintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_view_paint(inputs)
	return zh_landing_studio_view_paint(inputs)
});
export { landing_studio_view_paint as "landing.studio.view_paint" }